import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconClose = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-4 -4 24 24" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M15.0701 2.3392L13.6601 0.929199L8.00005 6.5892L2.34005 0.929199L0.930054 2.3392L6.59005 7.9992L0.930054 13.6592L2.34005 15.0692L8.00005 9.4092L13.6601 15.0692L15.0701 13.6592L9.41005 7.9992L15.0701 2.3392Z" }))));
};
